import React from "react";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
import useConstant from "use-constant";

// Formik
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-mui";

// Custom
import GroupsFilter from "../../components/FormikFields/Filters/GroupsFilter";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import ExpandableFilters from "../../components/Filters/ExpandableFilters";

// Material UI
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button } from "@mui/material";

const PositionsFilters = ({ onSubmit }) => {
  const { t } = useTranslation();

  const initialValues = {
    name_cont: "",
    groups_id_eq: ""
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {({ submitForm, handleReset }) => {
        const debouncedSubmit = useConstant(() => debounce(submitForm, 500));
        return (
          <Form>
            <ExpandableFilters
              staticContent={
                <Field
                  fullWidth
                  label={t("positions.filters.search")}
                  variant="filled"
                  component={TextField}
                  name={"name_cont"}
                  onKeyUp={debouncedSubmit}
                  type="text"
                  disabled={false}
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                />
              }
              expandableContent={
                <Box display="flex" flex={1} flexWrap="wrap" mb={-2}>
                  <Box display="flex" flex={1} mr={2} minWidth={260} pb={2}>
                    <GroupsFilter
                      fieldName="groups_id_eq"
                      filters={{ active: true, hasPositions: true }}
                    />
                  </Box>
                  <Box display="flex" alignItems="center" minWidth={208} pb={2}>
                    <ButtonGroup>
                      <Button
                        color="primary"
                        onClick={() => {
                          handleReset();
                          submitForm();
                        }}
                      >
                        {t("positions.filters.clearAll")}
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={submitForm}
                      >
                        {t("filterList")}
                      </Button>
                    </ButtonGroup>
                  </Box>
                </Box>
              }
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default PositionsFilters;
